import { Component, ViewChild } from "@angular/core";
import { ModalController, Nav, Platform } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../services/localStorage.service";
import { Firebase } from "@ionic-native/firebase";
import { API } from "../services/api";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import { MessagePresenter } from "../services/message.service";
import { ChatService } from "../services/chat.service";
import { ImageLoaderConfig } from "ionic-image-loader";
import * as moment from "moment";
import { FeatureFlags } from "../services/featureFlags";
import { environment } from "./app.module";
import { StatusBar } from "@ionic-native/status-bar";
import { CacheService } from "ionic-cache";
import { Utils } from "../services/Utils";
import { NotificationsService } from "../services/notifications.service";

import { Cordova } from "@ionic-native/core";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any; // LoginPage
  team: any;
  uid: any;
  subscription: any;

  constructor(
    private platform: Platform,
    private localStorage: LocalStorageService,
    private translate: TranslateService,
    private firebase: Firebase,
    private modalCtrl: ModalController,
    private api: API,
    private statusBar: StatusBar,
    private screenOrientation: ScreenOrientation,
    private messagePresenter: MessagePresenter,
    private chatService: ChatService,
    private imageLoaderConfig: ImageLoaderConfig,
    private fFlags: FeatureFlags,
    private cache: CacheService,
    private utils: Utils,
    private notificationsService: NotificationsService,
  ) {
    this.notificationsService.setBadgeNumber(0);
    //this.firebase.setBadgeNumber(0);
    this.updateFeatureFlags();
    this.initializeApp();
  }

  initializeApp() {
    // console.log("initialize...")
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      // disable spinners by default, you can add [spinner]="true" to a specific component instance later on to override this
      this.imageLoaderConfig.enableSpinner(false);

      if (!this.fFlags.DiningRooms) {
        // set the maximum concurrent connections to 10
        this.imageLoaderConfig.setConcurrency(15);
        this.chatService.trackNotifications();

        this.manageUserAppEvents();
      }

      if (this.utils.getIsApp()) {
        console.log('entro en if getisApp');
        
        // this.screenOrientation.lock(
        //   this.screenOrientation.ORIENTATIONS.PORTRAIT
        // );
      }

      // This language will be used as a fallback when a
      // translation isn't found in the current language.
      this.translate.addLangs(["es", "en"]);
      this.translate.setDefaultLang("en");

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      const browserLang = this.translate.getBrowserLang();
      this.translate.use(
        browserLang == "es" || browserLang == "ca" ? "es" : "en"
      );
      moment.locale(this.translate.currentLang);

      this.cache.setDefaultTTL(60 * 5); // set default cache TTL for 5 min

      this.showTheSplash();
    });
  }

  updateFeatureFlags() {
    console.log("environment seleccionado" + environment.toString());
    switch (environment.toString()) {
      case "colevisaempresas":
        this.fFlags.setDiningRooms = true;
        this.fFlags.setClonColevisa = false;
        this.fFlags.setClonStartUpv = false;
        this.fFlags.setClonLaberit = false;
        this.statusBar.backgroundColorByHexString("#82a9e6");
        break;
      case "soycolevisa":
        this.fFlags.setDiningRooms = false;
        this.fFlags.setClonColevisa = true;
        this.fFlags.setClonStartUpv = false;
        this.fFlags.setClonLaberit = false;
        this.statusBar.backgroundColorByHexString("#89ade7");
        break;
      case "startupv":
        this.fFlags.setDiningRooms = false;
        this.fFlags.setClonColevisa = false;
        this.fFlags.setClonStartUpv = true;
        this.fFlags.setClonLaberit = false;
        this.statusBar.backgroundColorByHexString("#0072ce");
        break;
      case "laberit":
        this.fFlags.setDiningRooms = false;
        this.fFlags.setClonColevisa = false;
        this.fFlags.setClonStartUpv = false;
        this.fFlags.setClonLaberit = true;
        this.statusBar.backgroundColorByHexString("#c10016");
        break;

      default:
        this.statusBar.backgroundColorByHexString("#B60000");
        this.fFlags.setDiningRooms = false;
        this.fFlags.setClonColevisa = false;
        this.fFlags.setClonStartUpv = false;
        this.fFlags.setClonLaberit = false;
        break;
    }
  }

  manageUserAppEvents() {
    this.platform.pause.subscribe((event) => {
      this.chatService.updateUserConnectionStatus(false);
    });

    this.platform.resume.subscribe((event) => {
      this.localStorage.getDateBackgroundMode().then((value) => {
        const dateNew = new Date().getTime();
        if (dateNew > value + 900000 && this.platform.is("ios")) {
          this.showSplashLottie();
        }
      });
      this.chatService.updateUserConnectionStatus(true);
    });
  }

  showTheSplash() {
    if (this.isLottieSupported()) {
      this.showSplashLottie();
      return;
    }
    this.showSplashStatic();
  }

  isLottieSupported() {
    if (this.platform.is("android")) {
      const version = this.platform.versions();
      if (version.android.num < 5) {
        return false;
      }
    }
    return true;
  }

  showSplashLottie() {
    const splash = this.modalCtrl.create("AnimatedSplash");
    splash.present({ animate: false });
    splash.onDidDismiss(() => {
      this.dismissAnySplash();
    });
  }

  showSplashStatic() {
    const splash = this.modalCtrl.create("Splash");
    splash.present({ animate: false });
    splash.onDidDismiss(() => {
      this.dismissAnySplash();
    });
  }

  dismissAnySplash() {
    if (this.utils.getIsApp()) {
      this.initFCM();
    }
  }

  initFCM() {
    // Send token firebaseConfig
    if (this.platform.is("ios")) {
      this.firebase.grantPermission();
    }

    this.getNotificationReceived();

    // get firebase token if user is logged
    this.localStorage.getToken().then((response) => {
      if (response != null) {
        // this.localStorage.getTokenFirebase().then((firebase) => {
        //   console.log(firebase);
        //   console.log("tokeeen");

        //   this.checkTokenFirebase(firebase);
        // });
      }
    });
  }

  // fcmOnNotifications() {
  //   this.fcm.onNotification().subscribe((data) => {
  //     console.log("data fcmOnNotifications", data);

  //     if (data.wasTapped) {
  //       console.log("Received in background");
  //     } else {
  //       console.log("Received in foreground");
  //       this.platform.ready().then(() => {
  //         console.log("thos.platformFcm");

  //         //this.getNotificationReceived();
  //       });
  //     }
  //   });
  // }

  getNotificationReceived() {
    // this.firebase.onNotificationOpen().subscribe((notification) => {
    //   if (!notification.tap && this.platform.is("android")) {
    //     const toast = this.messagePresenter.presentNotification(
    //       notification.body,
    //       5000,
    //       "top",
    //       true
    //     );
    //     toast.present();
    //   }
    // });
  }

  checkTokenFirebase(tokenLocal) {
    // console.error(this.firebase);
    // console.error(JSON.stringify(this.firebase));
    // this.firebase.getToken().then((token) => {
    //   console.warn(JSON.stringify(token));
    //   if (!tokenLocal) {
    //     this.setTokenFirebaseAndRegisterDevice(token);
    //   } else if (token != tokenLocal) {
    //     this.firebase.onTokenRefresh().subscribe((tokenRefresh) => {
    //       this.setTokenFirebaseAndRegisterDevice(tokenRefresh);
    //     });
    //   }
    // });
  }

  setTokenFirebaseAndRegisterDevice(newToken) {
    this.localStorage.setTokenFirebase(newToken).then((saveToken) => {
      this.api
        .registerDevice({ token: saveToken })
        .then((response) => {})
        .catch((error) => {});
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts